var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isVisible)?_c('div',{class:_setup.classList},[_vm._t("default",null,{"handleSlide":_setup.handleSlide,"isCollapsed":_setup.isCollapsed,"isStickyScrollingContent":_setup.isStickyScrollingContent})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }